export const admin = {
  name: "Ajay Soni",
  writerProfile:
    "https://firebasestorage.googleapis.com/v0/b/sr-devops.appspot.com/o/WhatsApp%20Image%202021-04-11%20at%2010.44.50%20PM.jpeg?alt=media&token=123de22f-ee70-46d5-bb0c-7af2d52fb303",
  desc: "Ajay Soni is the founder and CEO of SR DevOps, a software company. Experienced in mobile app development and web development having more than 2 years of experience in the industry.",
};
